import React, {Fragment} from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import type {Product, RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'
import {getDomainConfig} from '~/domains'
import {cssDomains} from '~/utils/constants'
import TopPicksCard from './top-picks-card'
import TopPicksUpdatedCard from './top-picks-card-new-layout'
import TopPicksSpecsCard from './top-picks-card-specs-layout'
import CompareTopPicks from './compare'
import {getTopPicksProducts, shouldShowTopPicks} from './show-top-picks'

const TopPicks = ({products, showProductPageLinks = true}: {products: Product[]; showProductPageLinks?: boolean}) => {
  const {language, isUSLocale, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {domainType, domainName} = getDomainConfig(domain, locale)
  const showTopPicks = shouldShowTopPicks(products)
  const isInsiderDomain = domainType === 'insider'
  const hideTitle = isInsiderDomain
  const productsForCompare = getTopPicksProducts(products)

  const renderCard = (index: number, product: Product) => {
    switch (true) {
      case isInsiderDomain:
        return <TopPicksSpecsCard index={index} product={product} />
      case isUSLocale || cssDomains.includes(domainName):
        return <TopPicksUpdatedCard index={index} product={product} showProductPageLinks={showProductPageLinks} />
      default:
        return <TopPicksCard index={index} product={product} />
    }
  }

  return showTopPicks ? (
    <section
      className={clsx('flex flex-col', {
        'mb-8 desktop:mt-5': isInsiderDomain,
        'mb-0': hideTitle,
      })}
      data-testid="top-picks"
      id="topPicks"
    >
      {hideTitle ? null : <h2 className="my-3 text-2xl font-semibold capitalize">{translations.TopPicks.title}</h2>}
      <div className="mt-5 flex flex-col gap-8">
        {productsForCompare?.map((product, i) => {
          return product?.brief && !!product?.brief.length ? (
            <Fragment key={`${product.asin}-${i}`}>{renderCard(i, product)}</Fragment>
          ) : null
        })}
      </div>
      <CompareTopPicks products={productsForCompare} />
    </section>
  ) : null
}

export default TopPicks
